import { render, staticRenderFns } from "./StudentEnrolledModal.vue?vue&type=template&id=dbd3170c&scoped=true&"
import script from "./StudentEnrolledModal.vue?vue&type=script&lang=js&"
export * from "./StudentEnrolledModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd3170c",
  null
  
)

export default component.exports